import { currentUrl, urlToString } from "Shared/url";
import { addToCart } from "./action-creators";
import { toggleMiniCart } from "SiteLayout/MiniCart/action-creators";
import { toNumber } from "./action-creators";
import { replaceState } from "Shared/history";
const queryParam = "ScriptIntoCart";
export default (store) => {
    const url = currentUrl();
    const queryValue = url.query[queryParam];
    if (queryValue && typeof queryValue === "string") {
        const add = queryValue.split("+").map((value) => {
            value = value.trim();
            if (!value.includes("*")) {
                value = value + "*1*"; // default quantity and empty unit
            }
            const [code, quantity, unitShortName] = value.split("*");
            return {
                code,
                quantity: toNumber(quantity) || 1,
                unitShortName: unitShortName,
            };
        });
        Promise.all(add.map((add) => store.dispatch(addToCart(add.code, add.quantity, add.unitShortName, null, "AddToCartFromLink")))).then(() => store.dispatch(toggleMiniCart()));
        // `replaceState` because if the user refreshes the page we don't want to
        // add the item again
        delete url.query[queryParam];
        replaceState(urlToString(url));
    }
};
